'use client'
import Link from 'next/link'

import Button from '@/shared/components/button/Button'
import CheckBox from '@/shared/components/modal/CheckBox'
import { Tint, Text } from '@/shared/components/typography'

import useTicketDetailViewModel from './viewModel'

type PurchaseTermsProps = {
  contentHeight: number
  footerRef: React.LegacyRef<HTMLDivElement>
}

const PurchaseTerms = ({ contentHeight, footerRef }: PurchaseTermsProps) => {
  const { states, handlers } = useTicketDetailViewModel()
  return (
    <>
      <div className={`flex flex-1 justify-center`} style={{ height: contentHeight, overflow: 'scroll' }}>
        <div className="flex flex-1 flex-col items-center bg-010 pt-4">
          <Text level="text1" color="text090" weight="bold">
            이용약관에 동의해주세요.
          </Text>

          <div className="mb-10 mt-6 flex w-full flex-1 flex-col gap-2 px-[16px]">
            <div className="mx-[16px] my-4">
              <CheckBox
                onChange={handlers.handleAllCheckChange}
                checked={states.allChecked}
                text="전체 내용에 동의합니다."
                color="text090"
              />
            </div>
            <div className="flex flex-col rounded-lg bg-020 py-2">
              {states.checkedItems.map((item, i) => (
                <div key={i} className="mx-[16px] my-4 flex items-center justify-between gap-3">
                  <CheckBox
                    className="check"
                    onChange={(event) => handlers.handleCheckChange(event, i)}
                    checked={item.check}
                    text={item.text}
                    color="text090"
                  />
                  <Link className="min-w-[22px]" href={item.route} target="_blank">
                    <Tint level="tint1" style="underline" color="text070" className="whitespace-nowrap">
                      보기
                    </Tint>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="sticky bottom-0" ref={footerRef}>
        <div className="flex w-full bg-010 px-4 py-3">
          <Button
            text="다음"
            color="text010"
            background="bg030"
            onClick={handlers.handleNextBtn}
            disabled={states.disabledChecked}
            className="body-1 h-[56px]"
            pyValue="py-0"
          />
        </div>
      </div>
    </>
  )
}

export default PurchaseTerms
